import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Check as CheckIcon, Block as BlockIcon } from "@material-ui/icons"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"

import { FeatureFlagEligibilityCheck } from "../store/types"

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
})

export interface Props {
  flags: FeatureFlagEligibilityCheck[]
}

const FeatureFlagCheckTable: React.FC<Props> = ({ flags }) => {
  const classes = useStyles()

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="Tags">
        <TableHead>
          <TableRow>
            <TableCell>Flag Name</TableCell>
            <TableCell>Check Time</TableCell>
            <TableCell>Exists</TableCell>
            <TableCell>Eligible</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {flags.map(({ name, flag, timestamp }) => (
            <TableRow
              key={timestamp}
              data-qa-selector={`tag-row-${name}-${flag.eligible}`}
            >
              <TableCell component="th" scope="row">
                {name}
              </TableCell>
              <TableCell>{new Date(timestamp).toLocaleString()}</TableCell>
              <TableCell>{getIcon(flag.exists)}</TableCell>
              <TableCell>{getIcon(flag.eligible)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function getIcon(val: boolean): React.ReactElement {
  return val ? <CheckIcon /> : <BlockIcon />
}

export default FeatureFlagCheckTable
